<template>
  <div>
    <div class="hm-headline">
      <span class="headline">充值档位管理</span>
      <span class="subhead">设置充值档位-{{ subTitle }}</span>
    </div>
    <el-card>
      <el-form
        label-position="top"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <div class="flex">
          <el-form-item prop="denomination" label="面额" class="mr">
            <el-input
              size="small"
              clearable
              placeholder="例：98.90元"
              v-model.trim="ruleForm.denomination"
            ></el-input>
            <span class="unit">元</span>
            <span class="form-tip">(注：建议5字以内)</span>
          </el-form-item>
          <el-form-item prop="rechargeAmount" label="充值金额" class="mr">
            <el-input
              size="small"
              @mousewheel.prevent.native
              type="number"
              clearable
              placeholder="例：98.90元"
              v-model.trim="ruleForm.rechargeAmount"
            ></el-input>
            <span class="unit">元</span>
          </el-form-item>
          <el-form-item label="赠送">
            <el-input
              size="small"
              @mousewheel.prevent.native
              type="number"
              clearable
              placeholder="例：98.90元"
              v-model.trim="ruleForm.donationAmount"
            ></el-input>
            <span class="unit">元</span>
          </el-form-item>
        </div>
        <el-form-item label="类型">
          <el-radio-group v-model="ruleForm.type" size="small">
            <el-radio :label="0">普通</el-radio>
            <el-radio :label="1">首充</el-radio>
            <el-radio :label="2">特惠</el-radio>
            <el-radio :label="3">活动</el-radio>
          </el-radio-group>
          <span class="form-tip"
            >(注：选择不同类型，充值入口显示不同角标，不选择时不显示角标)</span
          >
        </el-form-item>
        <div>
          <el-form-item label="有效时间">
            <el-radio-group v-model="ruleForm.valid" class="mr" size="small">
              <el-radio :label="0">永久有效</el-radio>
              <el-radio :label="1">时间段</el-radio>
            </el-radio-group>
            <el-date-picker
              size="small"
              v-show="ruleForm.valid === 1"
              v-model="ruleForm.validDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="排序">
          <el-input
            size="small"
            @mousewheel.prevent.native
            type="number"
            clearable
            v-model.trim="ruleForm.sort"
          ></el-input>
          <span class="form-tip">(注：数字越小越靠前)</span>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper text-center">
        <el-button
          size="small"
          type="primary"
          round
          @click="save"
          :loading="isSaving"
          >保存</el-button
        >
        <el-button size="small" round @click="back">返回</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    const patternFunc = (rule, val, callback) => {
      if (val <= 0) {
        return callback(new Error("请输入大于0的数"));
      }
      callback();
    };
    return {
      subTitle: "",
      displayMode: this.$route.params.type,
      pickedGoodsLength: false,
      data: [],
      rules: {
        denomination: [
          { required: true, message: "请输入面额", trigger: "blur" },
          { min: 1, max: 5, message: "长度在 1 到 5 个字符", trigger: "blur" }
        ],
        rechargeAmount: [
          { required: true, message: "请输入充值金额", trigger: "blur" },
          { validator: patternFunc, trigger: "blur" }
        ]
      },
      ruleForm: {
        denomination: "",
        rechargeAmount: "",
        type: "",
        donationAmount: "",
        valid: 0,
        sort: "",
        validDate: [new Date("2099-12-30"), new Date("2099-12-31")]
      }
    };
  },

  components: {},

  created() {
    if (this.displayMode === "edit") {
      const {
        denomination,
        rechargeAmount,
        donationAmount,
        type,
        validTimeRangeStart,
        validTimeRangeEnd,
        sort
      } = this.$route.query;
      this.ruleForm.denomination = denomination;
      this.ruleForm.rechargeAmount = parseInt(rechargeAmount);
      this.ruleForm.donationAmount = parseInt(donationAmount);
      this.ruleForm.type = parseInt(type);
      this.ruleForm.valid = 1;
      this.ruleForm.sort = sort;
      if (
        moment(parseInt(validTimeRangeStart)).isSame(
          moment("2099-12-30"),
          "year"
        )
      ) {
        this.ruleForm.valid = 0;
        this.ruleForm.validDate = [
          new Date("2099-12-30"),
          new Date("2099-12-31")
        ];
      } else {
        this.ruleForm.valid = 1;
        this.ruleForm.validDate = [
          new Date(parseInt(validTimeRangeStart)),
          new Date(parseInt(validTimeRangeEnd))
        ];
      }
    }
  },
  computed: mapState({
    addRechargeLevelCode: state => state.recharge.addRechargeLevelCode,
    upDateRechargeLevelCode: state => state.recharge.upDateRechargeLevelCode
  }),
  watch: {
    addRechargeLevelCode(val) {
      if (val === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.$router.back();
      }
      this.$store.commit("addRechargeLevel", "");
    },
    upDateRechargeLevelCode(val) {
      if (val === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.$router.back();
      }
      this.$store.commit("upDateRechargeLevel", "");
    },
    "ruleForm.valid": {
      handler(val) {
        if (val === 0) {
          this.ruleForm.validDate = [
            new Date("2099-12-30"),
            new Date("2099-12-31")
          ];
        } else if (val === 1) {
          this.ruleForm.validDate = [new Date(), new Date()];
        }
      },
      deep: true
    }
  },

  methods: {
    back() {
      this.$router.back();
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const validTimeRangeStart =
            this.ruleForm.validDate &&
            this.ruleForm.validDate.length > 0 &&
            moment(this.ruleForm.validDate[0]).format("YYYY-MM-DD HH:mm:ss");
          const validTimeRangeEnd =
            this.ruleForm.validDate &&
            this.ruleForm.validDate.length > 0 &&
            moment(this.ruleForm.validDate[1]).format("YYYY-MM-DD HH:mm:ss");
          if (this.displayMode === "edit") {
            this.$store.dispatch("upDateRechargeLevel", {
              id: this.$route.query.id,
              denomination: this.ruleForm.denomination,
              rechargeAmount: this.ruleForm.rechargeAmount,
              donationAmount: this.ruleForm.donationAmount,
              sort: this.ruleForm.sort,
              type: this.ruleForm.type,
              validTimeRangeStart,
              validTimeRangeEnd
            });
          } else {
            this.$store.dispatch("addRechargeLevel", {
              denomination: this.ruleForm.denomination,
              rechargeAmount: this.ruleForm.rechargeAmount,
              donationAmount: this.ruleForm.donationAmount,
              sort: this.ruleForm.sort,
              type: this.ruleForm.type,
              validTimeRangeStart,
              validTimeRangeEnd
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  padding: 10px 0;
}

.form-tip {
  font-size: 12px;
  color: #999;
  margin-left: 0.5rem;
}

.mr {
  margin-right: 2rem;
}
</style>
